// extracted by mini-css-extract-plugin
module.exports = {"container":"formHeaderSection_container__gGKH5"};